// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
 * ValueReset — a "mező + reset-gomb" sor elrendezése. Csak layout: szín nincs
 * benne, az a témából jön (lásd ValueReset.tsx).
 * ========================================================================= */

.uc-value-reset {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    width: 100%;
}

/* A mező viszi a sor maradék szélességét; a min-width: 0 kell, hogy a hosszú
   beviteli mezők ne feszítsék szét a sort. */
.uc-value-reset__field {
    flex: 1;
    min-width: 0;
}

/* A gomb sosem zsugorodik, és optikailag a beviteli sor közepére kerül
   (a mező kb. 40px magas, a gomb 28px). */
.uc-value-reset__button {
    flex: 0 0 auto;
    margin-top: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/v2/common/inputs/ValueReset.css"],"names":[],"mappings":"AAAA;;;8EAG8E;;AAE9E;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,WAAW;AACf;;AAEA;6CAC6C;AAC7C;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;0CAC0C;AAC1C;IACI,cAAc;IACd,eAAe;AACnB","sourcesContent":["/* ============================================================================\n * ValueReset — a \"mező + reset-gomb\" sor elrendezése. Csak layout: szín nincs\n * benne, az a témából jön (lásd ValueReset.tsx).\n * ========================================================================= */\n\n.uc-value-reset {\n    display: flex;\n    align-items: flex-start;\n    gap: 4px;\n    width: 100%;\n}\n\n/* A mező viszi a sor maradék szélességét; a min-width: 0 kell, hogy a hosszú\n   beviteli mezők ne feszítsék szét a sort. */\n.uc-value-reset__field {\n    flex: 1;\n    min-width: 0;\n}\n\n/* A gomb sosem zsugorodik, és optikailag a beviteli sor közepére kerül\n   (a mező kb. 40px magas, a gomb 28px). */\n.uc-value-reset__button {\n    flex: 0 0 auto;\n    margin-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
